var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftIconDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 21.75A2.25 2.25 0 0 1 3 19.5v-7.538l-.151-.037a1.877 1.877 0 0 1-1.34-1.62l-.009-.18v-1.5c0-1.035.84-1.875 1.875-1.875h3.194l-.036-.053a3.356 3.356 0 0 1-.526-1.6L6 4.875a3.375 3.375 0 0 1 5.971-2.157l.028.037.03-.037a3.368 3.368 0 0 1 2.374-1.21l.222-.008a3.375 3.375 0 0 1 2.842 5.197l-.037.053h3.945c.974 0 1.776.744 1.866 1.694l.009.181v1.5c0 .853-.57 1.573-1.349 1.8l-.151.036V19.5a2.25 2.25 0 0 1-2.056 2.242l-.194.008H5.25zm6-9.75H4.5v7.5a.75.75 0 0 0 .628.74l.122.01h6V12zm9 0h-7.5v8.25h6.75a.75.75 0 0 0 .74-.628l.01-.122V12zm-9-3.75H3.375A.375.375 0 0 0 3 8.625v1.5c0 .207.168.375.375.375h7.875V8.25zm10.125 0H12.75v2.25h8.625a.376.376 0 0 0 .365-.29l.01-.085v-1.5a.375.375 0 0 0-.375-.375zM9.375 3a1.875 1.875 0 1 0 0 3.75h1.875V4.875l-.009-.18A1.875 1.875 0 0 0 9.375 3zm5.25 0c-1.036 0-1.875.84-1.875 1.875V6.75h1.875c.975 0 1.776-.744 1.866-1.694l.009-.181C16.5 3.839 15.66 3 14.625 3z",
    fill: "#192340",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftIconDark);
export default __webpack_public_path__ + "static/media/gift-icon-dark.2e6690e388dcf4f19da8ed5999af4e65.svg";
export { ForwardRef as ReactComponent };